import React, { Fragment, useState } from "react";
import icon from "../../assets/icon.png";
import cart from "../../assets/icons8-cart-96.png";
import { Link } from "react-router-dom";
import img from "../../assets/l3.png";
import img1 from "../../assets/lap2.jpg";
import img2 from "../../assets/cm104-1.jpg";
const CenterHead = () => {
  const [openSearch, setOpensearch] = useState(false);
  const handleOpen = () => {
    setOpensearch(!openSearch);
  };
  const [openCart, setOpenCart] = useState(false);
  const handleopenCart = () => {
    setOpenCart(!openCart);
  };
  return (
    <Fragment>
    <nav className="navbar navbar-static-top">
        <div className="navigation" id="sticky-nav">
          <div className="container relative">

            <div className="row">

              <div className="navbar-header">
                <button type="button" className="navbar-toggle" data-toggle="collapse" data-target="#navbar-collapse">
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                  <span className="icon-bar"></span>
                </button>
               
                <div className="nav-cart mobile-cart hidden-lg hidden-md">
                  <div className="nav-cart-outer">
                    <div className="nav-cart-inner">
                      <a href="#" className="nav-cart-icon">2</a>
                    </div>
                  </div>
                </div>
              </div> 

              <div className="header-wrap">
                <div className="header-wrap-holder">

                
                  <div className="nav-search hidden-sm hidden-xs">
                    <form method="get">
                      <input type="search" className="form-control" placeholder="Search" />
                      <button type="submit" className="search-button">
                        <i className="icon icon_search"></i>
                      </button>
                    </form>
                  </div>

              
                  <div className="logo-container">
                    <div className="logo-wrap text-center">
                      <Link to={"/"}>
                        <img className="logo" src={img} alt="logo"/>
                      </Link>
                    </div>
                  </div>


                  <div className="nav-cart-wrap hidden-sm hidden-xs">
                    <div className="nav-cart right">
                      <div className="nav-cart-outer">
                        <div className="nav-cart-inner">
                          <a href="#" className="nav-cart-icon">2</a>
                        </div>
                      </div>
                      <div className="nav-cart-container">
                        <div className="nav-cart-items">

                          <div className="nav-cart-item clearfix">
                            <div className="nav-cart-img">
                            <Link to={"/Singleproduct"}>
                                <img src={img1} alt="" />
                            </Link>
                            </div>
                            <div className="nav-cart-title">
                              <a href="#">
                                Ladies Bag
                              </a>
                              <div className="nav-cart-price">
                                <span>1 x</span>
                                <span>1250.00</span>
                              </div>
                            </div>
                            <div className="nav-cart-remove">
                              <a href="#"><i className="icon icon_close"></i></a>
                            </div>
                          </div>

                          <div className="nav-cart-item clearfix">
                            <div className="nav-cart-img">
                              <Link to={"/Singleproduct"}>
                                <img src={img2} alt=""/>
                              </Link>
                            </div>
                            <div className="nav-cart-title">
                              <a href="#">
                                Sequin Suit longer title
                              </a>
                              <div className="nav-cart-price">
                                <span>1 x</span>
                                <span>1250.00</span>
                              </div>
                            </div>
                            <div className="nav-cart-remove">
                              <a href="#"><i className="icon icon_close"></i></a>
                            </div>
                          </div>
                        </div>
                        <div className="nav-cart-summary">
                          <span>Cart Subtotal</span>
                          <span className="total-price">$1799.00</span>
                        </div>
                        <div className="nav-cart-actions mt-20">
                          <Link to={"cart"} className="btn btn-md btn-dark"><span>View Cart</span></Link>
                          <Link to={"checkout"} className="btn btn-md btn-color mt-10"><span>Proceed to Checkout</span></Link>
                        </div>
                      </div>
                    </div>
                    <div className="menu-cart-amount right">
                      <span>
                        Cart /
                        <a href="#"> $1299.50</a>
                      </span>
                    </div>
                  </div> 
                </div>
              </div> 

              <div className="nav-wrap">
                <div className="collapse navbar-collapse" id="navbar-collapse">
                  <ul className="nav navbar-nav">
                    <li id="mobile-search" className="hidden-lg hidden-md">
                      <form method="get" className="mobile-search relative">
                        <input type="search" className="form-control" placeholder="Search..."/>
                        <button type="submit" className="search-button">
                          <i className="icon icon_search"></i>
                        </button>
                      </form>
                    </li>
                    <li className="dropdown">
                      <Link to={"/"}>Home</Link>
                    </li>
                    <li className="dropdown">
                      <Link to={"/about"}>About</Link>                     
                    </li>
                     <li className="dropdown">
                      <Link to={"/category"}>Category</Link>
                      </li>
                    <li className="dropdown">
                      <Link to={"/contact"}>Contact</Link>
                    </li>
                    <li className="mobile-links">
                      <ul>
                        <li>
                          <a href="#">Login</a>
                        </li>
                        <li>
                          <a href="#">My Account</a>
                        </li>
                        <li>
                          <a href="#">My Wishlist</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div> 
              </div> 
          
            </div> 
          </div> 
        </div>
      </nav>
    </Fragment>
  );
};

export default CenterHead;
